import VueApexCharts from "vue-apexcharts";
import Vue from "vue";
Vue.use(VueApexCharts);
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("apexchart", VueApexCharts);
